import { Navigate, useNavigate } from "react-router";
import { TradeTermsLayout } from "../../components/tradeTermsAssignment/TradeTermsLayout";
import * as ROUTES from "../../constants/routes";
import { useProductCatalogueMode } from "../../hooks/useProductCatalogueMode";
import { AvailabilityTierContent } from "./AvailabilityTier";
import { AvailabilityTierNewDetail } from "./AvailabilityTierNewDetail";

export const AvailabilityTierNew = () => {
  const navigate = useNavigate();
  const mode = useProductCatalogueMode();

  if (mode.isBasicMode) {
    return <Navigate to={ROUTES.AVAILABILITY_TIERS} replace />;
  }

  if (!mode.isAdvancedMode) {
    return null;
  }

  return (
    <TradeTermsLayout
      title="New product catalogue"
      onClickLeftIcon={() => navigate(ROUTES.AVAILABILITY_TIERS)}
      aside={<AvailabilityTierNewDetail />}
      type="product catalogue"
      isNew
    >
      <div className="mx-auto flex w-full max-w-[920px] items-center gap-2">
        <AvailabilityTierContent isNewTier />
      </div>
    </TradeTermsLayout>
  );
};
